/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { MDDEResult } from "@sa/rep-mdde";
import { useDictionary, useOLAPTransformer, yearToCropYearFull, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dataService, dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import Highcharts, { SeriesOptionsType } from "highcharts";
import { useChartOptions } from "../../../../charts/useChartOptions";
import { legendPipe, chartPipe, tooltipPipe, addXAxisPipe } from "../../../../charts/pipes";
import { ContextReport1 } from "../Context";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";

const CATEGORIES_AXIS = "commodities.default";
const SERIES_AXIS = "countries.default";

export function useData(olapResult: OLAPResult | null, context: ContextReport1): OLAPTransformerResult | null {

  const commoditiesCountries = useHookSubscribe(null, context.commoditiesCountries$);
  const commoditiesNames = useHookSubscribe(null, context.commoditiesNames$);
  const countriesNames = useHookSubscribe(null, context.countriesNames$);
  const countriesRegionNames = useHookSubscribe(null, context.countriesRegionNames$);

  const [, categoriesDictionary] = useDictionary(dictionaryService, "slides-commodities");
  const [, seriesDictionary] = useDictionary(dictionaryService, "slides-countries");
  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if (!olapResult || !categoriesDictionary || !seriesDictionary) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${CATEGORIES_AXIS}.name`, (id: unknown, lcid: number) => {
          return commoditiesNames?.get(Number(id)) as any;
        }],
        [`${SERIES_AXIS}.name`, (id: unknown, lcid: number) => {
          return (countriesNames?.get(Number(id)) as any)[lcid];
        }]
      ]),
      attrsDictionaries: new Map([
        [CATEGORIES_AXIS, categoriesDictionary],
        [SERIES_AXIS, seriesDictionary],
      ]) as ReadonlyMap<string, Dictionary>
    }
  }, [olapResult, categoriesDictionary, seriesDictionary, commoditiesNames]);
  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${CATEGORIES_AXIS}.name`],
      rows: [`${SERIES_AXIS}.name`, `${SERIES_AXIS}.parent`],
      cellData: {
        inCell: ["Measures.change"],
        attributes: [`${CATEGORIES_AXIS}.name`, `${SERIES_AXIS}.name`, `${SERIES_AXIS}.parent`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
